module.exports = __webpack_public_path__ + "static/media/director4.9dc27dc6.jpg";